import Vue from "vue";
import PrintBoard from "./PrintBoard";
import { ClueType, CopyrightPlacement, IClue, Provider } from "js/crossword/types";
import { Puzzle } from "js/crossword/Puzzle";
import { getCopyrightData } from "../helpers/copyright";

import styles from "./css/PrintPage.module.css";
import { ILocalizedDate } from "js/framework/Localization/getLocalizationProvider";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  components: {
    PrintBoard
  },
  props: {
    puzzle: Puzzle,
  },
  computed: {
    acrossClues(): IClue[] {
      return this.puzzle.data.clues.filter((c: IClue) => c.type === ClueType.Across);
    },
    downClues(): IClue[] {
      return this.puzzle.data.clues.filter((c: IClue) => c.type === ClueType.Down);
    },
    localizedDate(): ILocalizedDate {
      return this.localization.getDate(this.puzzle.data.metaData.date!);
    },
  },
  render() {
    const copyright = getCopyrightData(this.puzzle.data.metaData.format);
    const showCopyright = copyright.placement === CopyrightPlacement.BOARD;
    const { weekdayName, complete } = this.localizedDate;

    return (
      <div id="printPage" ref="printPage">
        <div class={styles.container}>
          <div class={styles.header}>
            <div class={styles.headerDate}>{`${weekdayName}, ${complete}`}</div>
            <div class={styles.headerTitle}>{this.puzzle.data.metaData.title}</div>
            <div class={styles.headerAuthor}>{this.puzzle.data.metaData.author}</div>
          </div>

          <div style={{ display: "flex" }}>
            <div class={styles.cluesAcross}>
              <div class={styles.clueTypeHeader}>{this.localization.get("Across")}</div>
              {this.acrossClues.map((clue) => (
                <div class={styles.clueItem}>
                  <span class={styles.clueNumber}>{clue.identifier || clue.number}</span>
                  <span> {clue.text} </span>
                </div>
              ))}
            </div>
            <div>
              <div
                class={styles.board}
                style={{ height: !showCopyright ? "137.5mm" : "145mm" }}
              >
                <PrintBoard puzzle={this.puzzle}/>
                { showCopyright 
                  ? <div
                      class="board--copyright"
                      style={{ marginBottom: "3mm", fontSize: "4.5mm" }}>
                      { copyright.message }
                    </div>
                  : null }
              </div>
              <div class={styles.cluesDown}>
                <div class={styles.clueTypeHeader}>{this.localization.get("Down")}</div>
                {this.downClues.map((clue) => (
                  <div class={styles.clueItem}>
                    <span class={styles.clueNumber}>{clue.identifier || clue.number}</span>
                    <span> {clue.text} </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
